import { useEffect } from "react";

const CopyPasteProtection = ({ children }) => {
  useEffect(() => {
    const preventCut = (e) => e.preventDefault();
    const preventCopy = (e) => e.preventDefault();
    const preventPaste = (e) => e.preventDefault();
    const preventContextMenu = (e) => e.preventDefault();

    document.addEventListener("cut", preventCut);
    document.addEventListener("copy", preventCopy);
    document.addEventListener("paste", preventPaste);
    document.addEventListener("contextmenu", preventContextMenu);

    return () => {
      document.removeEventListener("cut", preventCut);
      document.removeEventListener("copy", preventCopy);
      document.removeEventListener("paste", preventPaste);
      document.removeEventListener("contextmenu", preventContextMenu);
    };
  }, []);

  return <>{children}</>;
};

export default CopyPasteProtection;
